import React from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


const PREFIX = 'DayPeriodSelectItem';

const classes = {
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    filterTextPrimary: `${PREFIX}-filterTextPrimary`,
    filterTextSecondary: `${PREFIX}-filterTextSecondary`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        minWidth: '100%',
    },

    [`& .${classes.selectEmpty}`]: {
        marginTop: theme.spacing(2),
    },

    [`& .${classes.filterTextPrimary}`]: {
        fontSize: theme.typography.pxToRem(14), /*fontsize of the menu and selected element*/
    },

    [`& .${classes.filterTextSecondary}`]: {
        fontSize: theme.typography.pxToRem(13), /*aparently not used*/
    }
}));

function DayPeriodSelect(props) {

    const {
        handleChangePeriod,
        dayPeriod,
        data, 
        required
    } = props;

    const menuItemArray = []
    for (var i = 0; i < data.length; i++) {
        menuItemArray.push(
            <MenuItem key = {data[i].id} value={data[i].name}>
                <Typography className={classes.filterTextPrimary}>
                {data[i].name}
                </Typography>
            </MenuItem>
        )
    }

    var labelText = "Selecciona un periodo de día";
    if (required) {
        labelText = <Box color="error.main"> Seleccione un periodo de día *</Box>;

    }

    return (
        <Root>
            <FormControl className={classes.formControl}>
                <Select value={dayPeriod} onChange={handleChangePeriod} displayEmpty className={classes.selectEmpty}>
                    <MenuItem value="" disabled>
                    <Typography component={'div'} className={classes.filterTextPrimary}>
                            {labelText}
                        </Typography>
                    </MenuItem>
                    {menuItemArray}
                </Select>
            </FormControl>
        </Root>
    );
}

function DayPeriodSelectItem(props) {
    return (
        <div>
            <ListItem>
                <ListItemText primary={
                    <DayPeriodSelect
                        {...props}
                    />
                } />
            </ListItem>
            <Divider />
        </div>
    )
}

export default DayPeriodSelectItem;